import { newsList } from "@/mocks/anime";

export default function NewsSection() {
  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-6">
          <span className="text-xs font-medium text-accent-600">追番情报</span>
          <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">
            最新动态与追番攻略
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {newsList.map((news) => (
            <article
              key={news.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={news.cover}
                  alt={`${news.title}配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50">
                  {news.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-950">
                  {news.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {news.excerpt}
                </p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span>{news.date}</span>
                  <span>{news.read}阅读</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}